/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import axios from 'axios'
import {CommonPaginationModel} from '../../../../Utils/commonPagination'
import {LogsFilterDropdown} from './LogsFilterDropDown'
import {LogsViewTable} from './LogsViewTable'
import {useDispatch, useSelector} from 'react-redux'
import {useAuth} from '../../../modules/auth'
import {
  dashboardCallLogsEffectiffCurrentPage,
  dashboardCallLogsEffectiffRowsPerPage,
  dashboardCallLogsEffectiffSearch,
  dashboardCallLogsInPersonCurrentPage,
  dashboardCallLogsInPersonRowsPerPage,
  dashboardCallLogsInPersonSearch,
  dashboardCallLogsOnDEmandCurrentPage,
  dashboardCallLogsOnDEmandRowsPerPage,
  dashboardCallLogsOnDEmandSearch,
  dashboardCallLogsOperatorCurrentPage,
  dashboardCallLogsOperatorRowsPerPage,
  dashboardCallLogsOperatorSearch,
  dashboardCallLogsScheduledCurrentPage,
  dashboardCallLogsScheduledRowsPerPage,
  dashboardCallLogsScheduledSearch,
} from '../../../redux/tableSlice/tableSlice'
import {CommonLoading} from '../../../../Utils/commonLoading'
import toaster from '../../../../Utils/toaster'
import moment from 'moment-timezone'

const API_URL = process.env.REACT_APP_API_URL
const itemsPerPage = Number(process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE) || 10

// The API returns isAiInterpretation as 0/1 (int?), so it must not be compared with === true
function isAiInterpretationFlag(row: any): boolean {
  const raw = row?.isAiInterpretation ?? row?.IsAiInterpretation ?? row?.isAIInterpretation
  if (raw === true || raw === 'true') return true
  return Number(raw) === 1
}

type Props = {
  callType: number
  pageTitle: string
  downloadPage: string
}

const MainLogs: React.FC<Props> = ({callType, pageTitle, downloadPage}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const tableRef = useRef<any>(null)
  const dispatch = useDispatch()
  const {currentUser} = useAuth()
  const [isLoading, setIsLoading] = useState(true)
  const [isExporting, setIsExporting] = useState(false)
  const [call_log, setcall_log] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const [totalItems, setTotalItems] = useState(0)

  const {currentPage, rowsPerPage, searchQuery, filterData} = useSelector((state: any) => {
    if (callType === 1) {
      return {
        currentPage: state.table.dashboardCallLogsOnDEmand[0].currentPage,
        rowsPerPage: state.table.dashboardCallLogsOnDEmand[0].rowsPerPage,
        searchQuery: state.table.dashboardCallLogsOnDEmand[0].searchQuery,
        filterData: state.table.dashboardCallLogsOnDEmand[0].filterData,
      }
    } else if (callType === 2) {
      return {
        currentPage: state.table.dashboardCallLogsInPerson[0].currentPage,
        rowsPerPage: state.table.dashboardCallLogsInPerson[0].rowsPerPage,
        searchQuery: state.table.dashboardCallLogsInPerson[0].searchQuery,
        filterData: state.table.dashboardCallLogsInPerson[0].filterData,
      }
    } else if (callType === 3) {
      return {
        currentPage: state.table.dashboardCallLogsOperator[0].currentPage,
        rowsPerPage: state.table.dashboardCallLogsOperator[0].rowsPerPage,
        searchQuery: state.table.dashboardCallLogsOperator[0].searchQuery,
        filterData: state.table.dashboardCallLogsOperator[0].filterData,
      }
    } else if (callType === 0) {
      return {
        currentPage: state.table.dashboardCallLogsScheduled[0].currentPage,
        rowsPerPage: state.table.dashboardCallLogsScheduled[0].rowsPerPage,
        searchQuery: state.table.dashboardCallLogsScheduled[0].searchQuery,
        filterData: state.table.dashboardCallLogsScheduled[0].filterData,
      }
    } else if (callType === 5) {
      return {
        currentPage: state.table.dashboardCallLogsEffectiff[0].currentPage,
        rowsPerPage: state.table.dashboardCallLogsEffectiff[0].rowsPerPage,
        searchQuery: state.table.dashboardCallLogsEffectiff[0].searchQuery,
        filterData: state.table.dashboardCallLogsEffectiff[0].filterData,
      }
    } else {
      return {
        currentPage: 1,
        rowsPerPage: itemsPerPage,
        searchQuery: '',
        filterData: {
          awsUserId_REQList: [],
          awsUserId_INTList: [],
          customerList: [],
          languageList: [],
          callStateList: [],
          serviceTypeList: [],
          backstopPartnerList: [],
          startDate: null,
          endDate: null,
          callType: callType,
        },
      }
    }
  })

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = searchQuery || ''
    }
    const dataWithCallType = {...(filterData || {}), callType}
    fetchcall_log(dataWithCallType, searchQuery || '', currentPage, rowsPerPage)
  }, [callType])

  const extractSearch = (sq: any): string => {
    if (!sq) return ''
    if (typeof sq === 'string') return sq.trim()
    if (typeof sq === 'object' && sq.search) return String(sq.search).trim()
    return ''
  }

  const isFilterApplied = (filters: any, search: any) => {
    const hasSearch = extractSearch(search).length > 0
    const hasFilter =
      filters &&
      typeof filters === 'object' &&
      Object.entries(filters).some(([key, v]) => {
        if (key === 'callType' || key === 'callTypeFilter') return false
        if (v === null || v === undefined) return false
        if (Array.isArray(v)) return v.length > 0
        if (typeof v === 'object')
          return Object.values(v).some(
            (iv) => iv !== null && iv !== undefined && String(iv).trim() !== ''
          )
        return String(v).trim() !== ''
      })
    return hasSearch || hasFilter
  }

  const fetchcall_log = async (
    passingData: any,
    searchQuery: any,
    currentPage: number,
    rowsPerPage: number
  ) => {
    setIsLoading(true)
    try {
      const searchValue = extractSearch(searchQuery)
      const params: Record<string, any> = {
        page: currentPage,
        items_per_page: rowsPerPage,
      }
      if (searchValue.length > 0) {
        params.search = searchValue
      }

      let response = await axios.post(`${API_URL}/AWSConnect/call-log-filter-v2`, passingData, {
        params,
      })

      const responseBody = response.data
      const rows = Array.isArray(responseBody?.data) ? responseBody.data : []
      const pagination = responseBody?.payload?.pagination ?? responseBody?.Payload?.Pagination
      const total = Number(pagination?.total ?? pagination?.Total ?? rows.length)
      const lastPage = Number(pagination?.last_page ?? pagination?.Last_page ?? (total > 0 ? 1 : 0))

      setcall_log(rows)
      setTotalPages(lastPage)
      setTotalItems(total)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const isSystemUser = currentUser?.result?.userType === 'SYSTEM'
  const isConsumer = currentUser?.result?.userType === 'CONSUMER'
  const useQuestionColumns =
    currentUser?.result?.userType === 'CONSUMER' || currentUser?.result?.userType === 'SYSTEM'
  const showOtherParticipantsNumber =
    currentUser?.result?.userType === 'CONSUMER' || isSystemUser
  const canExportCallLogs =
    isSystemUser ||
    (currentUser?.result?.userType === 'CONSUMER' && currentUser?.result?.role !== 'User')
  const shouldIncludeAppointmentId = callType === 0 || callType === 2
  const shouldIncludeConnectingTime = callType === 1 || callType === 0
  const callLogExportHeaders = [
    'Call ID',
    'Reference Call ID',
    'Call Status',
    ...(isSystemUser ? ['Call Ended By'] : []),
    isConsumer ? 'Interpreter ID' : 'Interpreter',
    ...(isSystemUser ? ['Interpreter ID'] : []),
    'Initially Picked By',
    'Date Time',
    'Company Name',
    'Requester',
    'Requester Number',
    'Available Agents',
    'Language',
    'Type',
    ...(isConsumer ? [] : ['Backstop Partner']),
    ...(shouldIncludeAppointmentId ? ['Appointment ID'] : []),
    'Queue / Hold Time',
    ...(shouldIncludeConnectingTime ? ['Connecting Time'] : []),
    'Total Duration',
    'Agent Duration',
    'Other Participants',
    ...(showOtherParticipantsNumber ? ['Other Participants Number'] : []),
    'Total Conference Duration',
  ]

  const getBackstopPartnerDisplay = (item: any): string => {
    const name =
      item?.backstopPartner ??
      item?.BackstopPartner ??
      item?.backstopPartnerName ??
      item?.BackstopPartnerName ??
      ''
    const trimmed = name != null ? String(name).trim() : ''
    return trimmed || '-'
  }

  const escapeCsv = (value: any) => {
    const str = value === null || value === undefined ? '' : String(value)
    if (/[",\n]/.test(str)) {
      return '"' + str.replace(/"/g, '""') + '"'
    }
    return str
  }

  const convertToCsv = (rows: any[]) => {
    if (!rows || rows.length === 0) {
      console.warn('convertToCsv: No rows provided')
      return callLogExportHeaders.join(',')
    }

    const formatDate = (date: any) => {
      if (!date) return ''

      try {
        // Parse the date - handle both ISO strings and formatted strings like "1/10/2026 2:20:04 PM"
        let parsedDate: moment.Moment

        if (typeof date === 'string') {
          // Try to parse as ISO first (most common from backend)
          if (date.includes('T') || date.includes('Z') || /^\d{4}-\d{2}-\d{2}/.test(date)) {
            // ISO format or date string - treat as UTC
            parsedDate = moment.utc(date)
          } else if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(date)) {
            // Already formatted like "1/10/2026 2:20:04 PM" - parse and treat as UTC
            parsedDate = moment.utc(date, 'M/D/YYYY h:mm:ss A')
          } else {
            // Try default parsing
            parsedDate = moment.utc(date)
          }
        } else {
          // Date object or timestamp
          parsedDate = moment.utc(date)
        }

        // Convert to EST timezone and format
        // EST is UTC-5, EDT is UTC-4 (daylight saving)
        // Using 'America/New_York' automatically handles DST
        return parsedDate.tz('America/New_York').format('M/D/YYYY h:mm:ss A')
      } catch (error) {
        console.warn('Error formatting date:', date, error)
        // Fallback: return as string if parsing fails
        return String(date)
      }
    }

    // Format duration to HH:mm:ss format (e.g., 02:32:22)
    // Handles both string (already formatted) and number (seconds) inputs
    const formatDuration = (value: number | string | null | undefined): string => {
      if (value === null || value === undefined) return '00:00:00'

      // If already formatted as HH:mm:ss string, return as-is
      if (typeof value === 'string') {
        // Check if it looks like HH:mm:ss format
        if (/^\d{2}:\d{2}:\d{2}$/.test(value)) {
          return value
        }
        // Try to parse as number if it's a numeric string
        const parsed = parseFloat(value)
        if (!isNaN(parsed)) {
          value = parsed
        } else {
          return '00:00:00'
        }
      }

      if (typeof value !== 'number' || value <= 0) return '00:00:00'

      const hours = Math.floor(value / 3600)
      const minutes = Math.floor((value % 3600) / 60)
      const secs = Math.floor(value % 60)
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs
        .toString()
        .padStart(2, '0')}`
    }

    // Pre-call Q&A now arrives from the backend as structured pairs (no delimited strings to split).
    const getPreCallQA = (item: any): {question: string; answer: string}[] => {
      const list = item?.preCallQA ?? item?.PreCallQA ?? []
      if (!Array.isArray(list)) return []
      return list
        .map((qa: any) => ({
          question: (qa?.question ?? qa?.Question ?? '').toString().trim(),
          answer: (qa?.answer ?? qa?.Answer ?? '').toString().trim(),
        }))
        .filter((qa: {question: string; answer: string}) => qa.question || qa.answer)
    }

    // Fallback single-column rendering for roles that don't get per-question columns.
    const formatQAList = (qaList: {question: string; answer: string}[]): string => {
      if (!qaList || qaList.length === 0) return ''
      return qaList
        .map(({question, answer}) => {
          if (question && answer) return `Q: ${question} | A: ${answer}`
          if (question) return `Q: ${question}`
          if (answer) return `A: ${answer}`
          return ''
        })
        .filter(Boolean)
        .join('; ')
    }

    const getCallStatus = (item: any): string => item?.callStatus ?? '-'

    const formatCallId = (item: any): string => {
      // Check if callId is already formatted (contains prefix like "AI-", "OPI-", "VRI-", or "OSI-")
      if (
        item?.callId &&
        item.callId !== '-' &&
        item.callId !== '' &&
        /^(AI|OPI|VRI|OSI)-\d+/.test(item.callId)
      ) {
        return item.callId
      }

      // Get the code - prefer code field (which is what the table uses)
      const code = item?.code || item?.id || item?.Id || item?.Code || item?.callId || ''

      if (!code || code === '-') return '-'

      // Get channel to determine prefix
      const channel = item?.channel || item?.callType || ''

      let prefix = ''
      const isAiInterpretation = isAiInterpretationFlag(item)

      if (isAiInterpretation) {
        prefix = 'AI-'
      } else {
        // Determine prefix based on channel
        if (
          channel === 'Voice' ||
          channel === 'OPI' ||
          channel === 'ON_DEMAND' ||
          channel === 'ON_SITE'
        ) {
          prefix = 'OPI-'
        } else if (channel === 'Video' || channel === 'VRI') {
          prefix = 'VRI-'
        } else if (channel === 'OSI' || channel === 'INPERSON') {
          prefix = 'OSI-'
        } else {
          // Default to OPI if channel is unknown
          prefix = 'OPI-'
        }
      }

      // Extract numeric part from code if it contains non-numeric characters
      const numericCode = String(code).replace(/\D/g, '')
      if (!numericCode) return '-'

      // Pad code to 6 digits
      const paddedCode = numericCode.padStart(6, '0')
      return `${prefix}${paddedCode}`
    }

    const isAiCall = (row?: any): boolean => {
      if (isAiInterpretationFlag(row)) return true
      const code = String(row?.code ?? row?.callId ?? row?.id ?? '')
      return /^AI-\d+/i.test(code)
    }

    const formatReferenceCallId = (item: any): string => {
      const fk =
        item?.fkCallHeaderReference ??
        item?.fK_CallHeaderReference ??
        item?.FK_CallHeaderReference ??
        null
      if (fk == null || Number(fk) <= 0) return ''
      // AI- prefix only when isAiInterpretation is 1, otherwise OPI-
      const prefix = isAiCall(item) ? 'AI' : 'OPI'
      return `${prefix}-${String(fk).padStart(6, '0')}`
    }

    const questionColumns: string[] = []
    if (useQuestionColumns) {
      const seen = new Set<string>()
      rows.forEach((item: any) => {
        getPreCallQA(item).forEach(({question}) => {
          if (question && !seen.has(question)) {
            seen.add(question)
            questionColumns.push(question)
          }
        })
      })
    }

    const headers = useQuestionColumns
      ? [...callLogExportHeaders, ...questionColumns]
      : [...callLogExportHeaders, 'Questions & Answers']

    const lines = rows.map((item: any, index: number) => {
      // Data comes in camelCase, so use camelCase property names
      const appointmentIdValue = shouldIncludeAppointmentId
        ? item?.appointmentId && item.appointmentId !== 0
          ? item.appointmentId
          : '-'
        : null

      // Format Type column to match web view (shows channel like "Voice", "Video", "OSI")
      const formatType = (item: any): string => {
        const channel = item?.channel || ''
        // If channel is available, use it directly (matches web view)
        if (channel) {
          return channel
        }
        // Fallback: map callType to channel format
        const callType = item?.callType || ''
        if (callType === 'ON_DEMAND' || callType === 'on_demand') {
          return 'Voice'
        } else if (callType === 'SCHEDULE' || callType === 'schedule') {
          // For scheduled calls, check if it's video or voice based on other fields
          // Default to Voice for scheduled calls
          return 'Voice'
        }
        return callType || '-'
      }

      const row = [
        escapeCsv(formatCallId(item)),
        escapeCsv(formatReferenceCallId(item)),
        escapeCsv(getCallStatus(item)),
        ...(isSystemUser ? [escapeCsv(item?.callEndedBy ?? item?.CallEndedBy ?? '-')] : []),
        escapeCsv(item?.interpreter || ''),
        ...(isSystemUser ? [escapeCsv(item?.interpreterUserId ?? '')] : []),
        escapeCsv(item?.initiallyPickedBy || ''),
        escapeCsv(formatDate(item?.initiationTimestamp || item?.createdDate)),
        escapeCsv(item?.clientName || item?.customer || ''),
        escapeCsv(item?.requester || item?.nameOfRequester || ''),
        escapeCsv(item?.requesterPhoneNumber || item?.RequesterPhoneNumber || ''),
        escapeCsv(item?.availableAgentCount ?? item?.AvailableAgentCount ?? '-'),
        escapeCsv(item?.toLanguage || ''),
        escapeCsv(formatType(item)),
        ...(isConsumer ? [] : [escapeCsv(getBackstopPartnerDisplay(item))]),
        ...(shouldIncludeAppointmentId ? [escapeCsv(appointmentIdValue)] : []),
        escapeCsv(
          (() => {
            // Calculate queue/hold time the same way as frontend (CallLogsHandler.cs logic)
            // First check if queueHoldTime is already provided
            let queueTime =
              item?.queueHoldTime ?? item?.queueTime ?? item?.QueueTime ?? item?.QueueHoldTime

            // If already formatted as HH:mm:ss string, return as-is
            if (typeof queueTime === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(queueTime)) {
              return queueTime
            }

            // If not available, calculate it the same way as backend does
            if (
              (queueTime === null ||
                queueTime === undefined ||
                queueTime === 0 ||
                queueTime === '00:00:00') &&
              item?.agentDuration !== undefined
            ) {
              // Helper to parse duration value (handles both HH:mm:ss and seconds)
              const parseDuration = (val: any): number => {
                if (typeof val === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(val)) {
                  const parts = val.split(':').map(Number)
                  return parts[0] * 3600 + parts[1] * 60 + parts[2]
                }
                return typeof val === 'string' ? parseFloat(val) : val || 0
              }

              const agentDuration = parseDuration(item.agentDuration)
              const totalDuration =
                parseDuration(item?.totalDuration) || parseDuration(item?.duration)

              if (agentDuration > 0) {
                // Queue time = TotalDuration - AgentDuration
                queueTime = totalDuration - agentDuration
              } else if (item?.isOperator === true || item?.isEffectiff === true) {
                // For operator/effectiff calls: TotalDuration - ConferenceDuration
                const conferenceDuration = parseDuration(item?.conferenceDuration)
                queueTime = totalDuration - conferenceDuration
              } else {
                // Otherwise use total duration
                queueTime = totalDuration
              }
            }

            // Format the result as HH:mm:ss
            if (queueTime !== null && queueTime !== undefined) {
              const numValue = typeof queueTime === 'string' ? parseFloat(queueTime) : queueTime
              if (!isNaN(numValue) && numValue >= 0) {
                const hours = Math.floor(numValue / 3600)
                const minutes = Math.floor((numValue % 3600) / 60)
                const secs = Math.floor(numValue % 60)
                return `${hours.toString().padStart(2, '0')}:${minutes
                  .toString()
                  .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
              }
            }
            return '00:00:00'
          })()
        ),
        ...(shouldIncludeConnectingTime ? [escapeCsv(item?.connectingTimeSeconds || '-')] : []),
        escapeCsv(formatDuration(item?.totalDuration || item?.duration)),
        escapeCsv(formatDuration(item?.agentDuration)),
        escapeCsv(item?.otherParticipents || ''),
        ...(showOtherParticipantsNumber ? [escapeCsv(item?.otherParticipantsNumber || '')] : []),
        escapeCsv(item?.conferenceDuration ? formatDuration(item.conferenceDuration) : 'N/A'),
      ]

      if (useQuestionColumns) {
        const answerByQuestion = new Map<string, string>()
        getPreCallQA(item).forEach(({question, answer}) => {
          if (question && !answerByQuestion.has(question)) {
            answerByQuestion.set(question, answer)
          }
        })
        questionColumns.forEach((q: string) => {
          row.push(escapeCsv(answerByQuestion.get(q) ?? ''))
        })
      } else {
        row.push(escapeCsv(formatQAList(getPreCallQA(item))))
      }

      return row.join(',')
    })

    const csv = [headers.join(','), ...lines].join('\n')

    return csv
  }

  const downloadCsv = (csv: string, filename: string) => {
    // Add UTF-8 BOM to ensure Excel correctly interprets special characters
    const BOM = '\uFEFF'
    const blob = new Blob([BOM + csv], {type: 'text/csv;charset=utf-8;'})
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const handleExport = async () => {
    try {
      setIsExporting(true)
      const searchValue = extractSearch(searchQuery)
      const exportAll = isFilterApplied(filterData, searchQuery)
      const params: any = {
        page: exportAll ? 1 : currentPage,
        items_per_page: rowsPerPage,
        export_all: exportAll,
      }

      if (searchValue.length > 0) {
        params.search = searchValue
      }

      const requestBody = {...(filterData || {}), callType}

      const response = await axios.post(`${API_URL}/AWSConnect/call-log-export-v2`, requestBody, {
        params: params,
      })

      const exportRows = response?.data?.data || []

      if (exportRows.length === 0) {
        toaster('warning', 'No data to export')
        return
      }

      const csv = convertToCsv(exportRows)

      if (!csv || csv.trim().length === 0 || csv.split('\n').length <= 1) {
        toaster('error', 'CSV generation failed - data structure mismatch')
        return
      }

      downloadCsv(csv, `call-logs-${moment().format('YYYY_MM_DD')}.csv`)
    } catch (error) {
      console.error('Error:', error)
      toaster('error', 'Failed to export call logs')
    } finally {
      setIsExporting(false)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const searchValue = inputRef.current?.value || ''
      const dataWithCallType = {...(filterData || {}), callType}
      if (callType === 1) {
        dispatch(dashboardCallLogsOnDEmandSearch(searchValue))
        dispatch(dashboardCallLogsOnDEmandCurrentPage(1))
      }
      if (callType === 0) {
        dispatch(dashboardCallLogsScheduledCurrentPage(1))
        dispatch(dashboardCallLogsScheduledSearch(searchValue))
      }
      if (callType === 2) {
        dispatch(dashboardCallLogsInPersonCurrentPage(1))
        dispatch(dashboardCallLogsInPersonSearch(searchValue))
      }
      if (callType === 3) {
        dispatch(dashboardCallLogsOperatorCurrentPage(1))
        dispatch(dashboardCallLogsOperatorSearch(searchValue))
      }
      if (callType === 5) {
        dispatch(dashboardCallLogsEffectiffCurrentPage(1))
        dispatch(dashboardCallLogsEffectiffSearch(searchValue))
      }
      fetchcall_log(dataWithCallType, searchValue, 1, rowsPerPage)
    }
  }

  return (
    <>
      <div className='card-body p-0'>
        <div className='rounded'>
          <div className='mt-4 d-flex justify-content-between flex-wrap align-items-center'>
            <div className='d-flex'>
              <h4 className='text-center mb-0'>{pageTitle}</h4>
            </div>
            <div className='d-flex flex-wrap'>
              <div className='d-flex align-items-center position-relative me-3 flex-nowrap'>
                <input
                  ref={inputRef}
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-white form-control-sm max-w-250px custom-search-radius'
                  placeholder='Search'
                  onKeyDown={handleKeyDown}
                  onChange={() => {
                    const value = inputRef.current?.value || ''
                    if (value === '') {
                      const dataWithCallType = {...(filterData || {}), callType}
                      if (callType === 1) {
                        dispatch(dashboardCallLogsOnDEmandSearch(''))
                        dispatch(dashboardCallLogsOnDEmandCurrentPage(1))
                      }
                      if (callType === 0) {
                        dispatch(dashboardCallLogsScheduledCurrentPage(1))
                        dispatch(dashboardCallLogsScheduledSearch(''))
                      }
                      if (callType === 2) {
                        dispatch(dashboardCallLogsInPersonCurrentPage(1))
                        dispatch(dashboardCallLogsInPersonSearch(''))
                      }
                      if (callType === 3) {
                        dispatch(dashboardCallLogsOperatorCurrentPage(1))
                        dispatch(dashboardCallLogsOperatorSearch(''))
                      }
                      if (callType === 5) {
                        dispatch(dashboardCallLogsEffectiffCurrentPage(1))
                        dispatch(dashboardCallLogsEffectiffSearch(''))
                      }
                      fetchcall_log(dataWithCallType, '', 1, rowsPerPage)
                    }
                  }}
                />

                <button
                  type='button'
                  className='btn btn-primary btn-icon btn-sm custom-search-btn-radius px-3'
                  onClick={() => {
                    const searchValue = inputRef.current?.value || ''
                    const dataWithCallType = {...(filterData || {}), callType}
                    if (callType === 1) {
                      dispatch(dashboardCallLogsOnDEmandSearch(searchValue))
                      dispatch(dashboardCallLogsOnDEmandCurrentPage(1))
                    }
                    if (callType === 0) {
                      dispatch(dashboardCallLogsScheduledCurrentPage(1))
                      dispatch(dashboardCallLogsScheduledSearch(searchValue))
                    }
                    if (callType === 2) {
                      dispatch(dashboardCallLogsInPersonCurrentPage(1))
                      dispatch(dashboardCallLogsInPersonSearch(searchValue))
                    }
                    if (callType === 3) {
                      dispatch(dashboardCallLogsOperatorCurrentPage(1))
                      dispatch(dashboardCallLogsOperatorSearch(searchValue))
                    }
                    if (callType === 5) {
                      dispatch(dashboardCallLogsEffectiffCurrentPage(1))
                      dispatch(dashboardCallLogsEffectiffSearch(searchValue))
                    }
                    fetchcall_log(dataWithCallType, searchValue, 1, rowsPerPage)
                  }}
                >
                  <KTSVG path='/media/icons/duotune/general/gen021.svg' className='' />
                </button>
              </div>
              {canExportCallLogs && (
                <OverlayTrigger
                  placement='top'
                  overlay={<Tooltip id='tooltip-filter'>Download CSV</Tooltip>}
                >
                  <button
                    type='button'
                    className='btn btn-primary btn-sm me-3 btn-icon'
                    onClick={handleExport}
                    disabled={isExporting}
                  >
                    <KTSVG
                      path='/media/icons/duotune/files/fil017.svg'
                      className='svg-icon-muted'
                    />
                  </button>
                </OverlayTrigger>
              )}

              <div className=''>
                <LogsFilterDropdown
                  setcall_log={setcall_log}
                  setTotalPages={setTotalPages}
                  setCurrentPage={currentPage}
                  setFilterData={filterData}
                  fetchcall_log={fetchcall_log}
                  searchQuery={searchQuery}
                  callType={callType}
                />
              </div>
            </div>
          </div>

          <div className='table-responsive mb-5 mt-3'>
            <LogsViewTable
              className={''}
              title={pageTitle}
              isLoading={isLoading}
              call_log={call_log}
              tableRef={tableRef}
              onRefresh={() => fetchcall_log({...(filterData || {}), callType}, searchQuery, currentPage, rowsPerPage)}
            />
          </div>
          <CommonPaginationModel
            currentPage={currentPage}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            total={totalItems}
            onPageChange={(page: number) => {
              const dataWithCallType = {...(filterData || {}), callType}
              if (callType === 1) {
                dispatch(dashboardCallLogsOnDEmandCurrentPage(page))
              }
              if (callType === 0) {
                dispatch(dashboardCallLogsScheduledCurrentPage(page))
              }
              if (callType === 2) {
                dispatch(dashboardCallLogsInPersonCurrentPage(page))
              }
              if (callType === 3) {
                dispatch(dashboardCallLogsOperatorCurrentPage(page))
              }
              if (callType === 5) {
                dispatch(dashboardCallLogsEffectiffCurrentPage(page))
              }
              fetchcall_log(dataWithCallType, searchQuery, page, rowsPerPage)
            }}
            onRowsPerPageChange={(newRowsPerPage: number) => {
              const dataWithCallType = {...(filterData || {}), callType}
              if (callType === 1) {
                dispatch(dashboardCallLogsOnDEmandRowsPerPage(newRowsPerPage))
                dispatch(dashboardCallLogsOnDEmandCurrentPage(1))
              }
              if (callType === 0) {
                dispatch(dashboardCallLogsScheduledRowsPerPage(newRowsPerPage))
                dispatch(dashboardCallLogsScheduledCurrentPage(1))
              }
              if (callType === 2) {
                dispatch(dashboardCallLogsInPersonRowsPerPage(newRowsPerPage))
                dispatch(dashboardCallLogsInPersonCurrentPage(1))
              }
              if (callType === 3) {
                dispatch(dashboardCallLogsOperatorRowsPerPage(newRowsPerPage))
                dispatch(dashboardCallLogsOperatorCurrentPage(1))
              }
              if (callType === 5) {
                dispatch(dashboardCallLogsEffectiffRowsPerPage(newRowsPerPage))
                dispatch(dashboardCallLogsEffectiffCurrentPage(1))
              }
              fetchcall_log(dataWithCallType, searchQuery, 1, newRowsPerPage)
            }}
          />
        </div>

        <img
          className='w-100 card-rounded-bottom'
          alt=''
          src='assetsmedia/svg/illustrations/bg-4.svg'
        />
      </div>
      {(isLoading || isExporting) && <CommonLoading />}
    </>
  )
}

export {MainLogs}
